import { render, staticRenderFns } from "./giftsee.vue?vue&type=template&id=a43df7e4&scoped=true&"
import script from "./giftsee.vue?vue&type=script&lang=js&"
export * from "./giftsee.vue?vue&type=script&lang=js&"
import style0 from "./giftsee.vue?vue&type=style&index=0&id=a43df7e4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a43df7e4",
  null
  
)

export default component.exports